
export type { IPageController } from "./page-controller";
export type { IPageObjectTreeService } from "./page-object-tree";
export type { PageCacheKey } from "./page-object-tree";

/********匿名用户相关类型********/
export { AnonymousPageController } from "./anonymous/anonymous-page.controller";
export type { IAnonymousUserLoginService } from "./anonymous/anonymous-user-login.service";
export type { IAnonymousPageObjectTreeService } from "./anonymous/anonymous-page-object-tree";

/********登录用户相关类型********/
export { AuthorizedPageController } from "./authorized/authorized-page.controller";
export type { IAuthorizedPageObjectTreeService } from "./authorized/authorized-page-object-tree";

export type { IResponseUser, IAnonymousResponseUser } from "./response-user";

export type { ILoginCacheKey } from "./login-cache-key";